export const normalizeErrors = error => {
	let res = ""

	Object.keys(error).forEach(function(key, index) {

		let value = this[key]
		if (value !== undefined) {
			if (typeof value === "string") {
				res = value
			} else if (typeof value === "object") {
				res = value[Object.keys(value)[0]][0]
			}
			return
		}
		else if(process.env.REACT_APP_STAGING || process.env.NODE_ENV === "development") {
			console.log("%cunknown error :", "font-size: 2em;color:red;", key)
		}
	}, error)

	if (res === "") {
		if(process.env.REACT_APP_STAGING || process.env.NODE_ENV === "development"){
			console.log("could not parse error : ", error)
		}
		res = "unknown_error"
	}

	return res
}


// WEBPACK FOOTER //
// ./src/normalizers/ErrorsNormalizer.js